const groupByWithValueMapper = <V, T>(
  list: V[],
  toKey: (value: V) => string,
  toValue: (value: V) => T,
): { [key: string]: T[] } =>
  list.reduce((acc: { [key: string]: T[] }, v: V) => {
    const k = toKey(v);
    (acc[k] = acc[k] || []).push(toValue(v));
    return acc;
  }, {});

const groupByNoValueMapper = <V,>(
  list: V[],
  toKey: (value: V) => string,
): { [key: string]: V[] } =>
  groupByWithValueMapper(list, toKey, (value) => value);

export function groupBy<V, T>(
  list: V[],
  toKey: (value: V) => string,
  toValue: (value: V) => T,
): { [key: string]: T[] };

export function groupBy<V>(
  list: V[],
  toKey: (v: V) => string,
): { [key: string]: V[] };

export function groupBy<V, T>(
  list: V[],
  toKey: (value: V) => string,
  toValue?: (value: V) => T | V,
): { [key: string]: (V | T)[] } {
  return toValue
    ? groupByWithValueMapper(list, toKey, toValue)
    : groupByNoValueMapper(list, toKey);
}
